import {IStore} from '../interfaces/store';

import {IMunicipality} from '../interfaces/municipality';

export function municipalitySelector(state: IStore): IMunicipality | null {
  return state.municipality;
}
